<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/settings/target-group'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom>
          <img [src]="'assets/images/target-audience.svg'">
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{name}}
          </div>
          <div class="subtitle secondary-text">
            <span>{{'targetGroup.setting' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->
      <div class="nav-buttons">
        @if (id) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="addNewTargetGroupSetting()">
            <span>{{'add_new' | translate}}</span>
          </button>
        }

        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          [disabled]="formGroup && formGroup.invalid" (click)="addTargetGroupSetting()">
          @if (!id) {
            <span>{{'main.add' | translate}}</span>
          }
          @if (id) {
            <span>{{'main.update' | translate}}</span>
          }
        </button>
      </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg" fusePerfectScrollbar>
      <div class="info-modal">{{'target-group-setting-info' | translate}}</div>

      <!-- CONTENT -->
      <div class="content">
        <div class="content-block">
          <form [formGroup]="formGroup" class="canton-form">
            <mat-checkbox class="width-100" formControlName="active">{{'targetGroup.active' | translate}}</mat-checkbox>
            <mat-form-field class="width-50">
              <mat-label>{{ 'age_group_title' | translate }}</mat-label>
              <input formControlName="title" matInput required>
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'targetGroup.creditTarget' | translate }}</mat-label>
              <input formControlName="creditTarget" matInput required type="number" min="0">
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'targetGroup.nextYear' | translate }}</mat-label>
              <input formControlName="maxTransfer" matInput required type="number" min="0">
            </mat-form-field>
          </form>
        </div>
      </div>
      @if (id) {
        <div class="content">
          <div class="content-block">
            <mat-card appearance="outlined" style="height: 100%">
              <mat-card-header>
                <div class="px-16 border-bottom" fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                  <div class="h2"><b>{{'sub_cred_tg' | translate}}</b></div>
                  <div>
                    <button mat-raised-button
                      class="save-product-button mat-white-bg mt-16 mt-sm-0"
                      (click)="addSubCreditTarget()">
                      <span>{{'subCreditTarget.add' | translate}}</span>
                    </button>
                  </div>
                </div>
              </mat-card-header>
              <mat-card-content>
                <div>
                  <div class="info-block">
                    <div style="margin: 2%;" >
                      <div class="info-credit-block">
                      </div>
                      <div class="item-cell">
                        <span class="mat-subtitle-1"><b>{{'event_type' | translate}}</b></span>
                      </div>
                      <div class="item-cell">
                        <span class="mat-subtitle-1"><b>Credit</b></span>
                      </div>
                      @if (subCreditTargets && subCreditTargets.length) {
                        @for (item of subCreditTargets; track item) {
                          <div style="width: 100%;display: flex;">
                            <div class="info-credit-block" [ngStyle]="{'background-color': item.eventType.color}">
                            </div>
                            <div class="item-cell">
                              <span class="mat-subtitle-1">{{item.eventType.name}}</span>
                            </div>
                            <div class="item-cell">
                              <span class="mat-subtitle-1">{{item.credit}}</span>
                            </div>
                            <div class="item-cell">
                              <button mat-icon-button (click)="editSubCreditTarget(item)">
                                <mat-icon>edit</mat-icon>
                              </button>
                            </div>
                          </div>
                        }
                      }
                      @if (newSubCreditTargets && newSubCreditTargets.length) {
                        <br>
                          @for (item of newSubCreditTargets; track item; let i = $index) {
                            <div style="width: 100%;display: flex;">
                              <div class="info-credit-block" [ngStyle]="{'background-color': item.eventType.color}">
                              </div>
                              <div class="item-cell">
                                <span class="mat-subtitle-1">{{item.eventType.name}}</span>
                              </div>
                              <div class="item-cell">
                                <span class="mat-subtitle-1">{{item.credit}}</span>
                              </div>
                              <div class="item-cell">
                                <button mat-icon-button (click)="removeNewSubCreditTarget(i)">
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>
                            </div>
                          }
                        }
                        @if (!subCreditTargets || !subCreditTargets.length) {
                          <div style="width: 100%;display: flex; justify-content: space-between">
                            <p>{{'no_data_tgs' | translate}}</p>
                          </div>
                        }
                        <div class="item-cell border-top" style="width: 100%; margin-bottom: 3%">
                          <span class="mat-headline-6"><b>{{'remains' |translate}}   </b>{{remain}} {{'credit' |translate}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="chart-block">
                      <div class="h-400" style="margin-top:3% ">
                        <ngx-charts-pie-chart
                          *fuseIfOnDom
                          [scheme]="widget6.scheme"
                          [results]="data"
                          [legendTitle]="'Credit-Teil-Soll'"
                          [legend]="widget6.legend"
                          [explodeSlices]="widget6.explodeSlices"
                          [labels]="widget6.labels"
                          [doughnut]="widget6.doughnut"
                          [gradient]="widget6.gradient">
                        </ngx-charts-pie-chart>
                      </div>
                    </div>
                  </div>
                  @if (archivedSettings.length) {
                    <div class="archived-settings">
                      <div class="archived-title">{{'archived_settings' | translate}}</div>
                      @for (setting of archivedSettings; track setting) {
                        <div>
                          <mat-accordion>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                  {{'archived_on' | translate}}
                                </mat-panel-title>
                                <mat-panel-description>
                                  {{setting.changeDate | date: 'dd.MM.YYYY HH:mm'}}
                                </mat-panel-description>
                              </mat-expansion-panel-header>
                              <div>{{'targetGroup.creditTarget' | translate}}: {{setting.creditTarget}}</div>
                              @if (setting.maxTransfer) {
                                <div>{{'targetGroup.maxTransfer' | translate}}: {{setting.maxTransfer}}</div>
                              }
                              @if (setting.subCreditTarget && setting.subCreditTarget.length) {
                                <br>
                                  <div><b>{{'sub_cred_tg' | translate}}</b></div>
                                  @for (item of setting.subCreditTarget; track item) {
                                    <div style="width: 100%;display: flex;">
                                      <div class="info-credit-block" [ngStyle]="{'background-color': item.eventType.color}">
                                      </div>
                                      <div class="item-cell">
                                        <span class="mat-subtitle-1">{{item.eventType.name}}</span>
                                      </div>
                                      <div class="item-cell">
                                        <span class="mat-subtitle-1">{{item.credit}}</span>
                                      </div>
                                    </div>
                                  }
                                }
                              </mat-expansion-panel>
                            </mat-accordion>
                          </div>
                        }
                      </div>
                    }
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          }

          <!-- / CONTENT -->


        </div>
        <!-- / CONTENT CARD -->

      </div>
      <!-- / CENTER -->
    </div>

